/*
 * Copyright © 2019 Franck Borel, Martin Helfer, Sebastian Schüpbach
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import {Action} from '@ngrx/store';
import {SavedQuery} from '../models/saved-query.model';

/***
 * @ignore
 */
/* eslint-disable @typescript-eslint/no-shadow */
export enum SavedQueryActionTypes {
  AddSavedQuery = '[SavedQuery] Add SavedQuery',
  AddSavedQueries = '[SavedQuery] Add SavedQueries',
  DeleteSavedQuery = '[SavedQuery] Delete SavedQuery',
}
/* eslint-enable @typescript-eslint/no-shadow */

/**
 * Adds a saved query
 */
export class AddSavedQuery implements Action {
  /**
   * @ignore
   */
  readonly type = SavedQueryActionTypes.AddSavedQuery;

  /**
   * Contains the saved query to be added
   * @param payload {Object}
   */
  constructor(public payload: { savedQuery: SavedQuery }) {
  }
}

/**
 * Adds several saved queries
 */
export class AddSavedQueries implements Action {
  /**
   * @ignore
   */
  readonly type = SavedQueryActionTypes.AddSavedQueries;

  /**
   * Contains saved queries to be added
   * @param payload {Object}
   */
  constructor(public payload: { savedQueries: SavedQuery[] }) {
  }
}

/**
 * Removes a saved query
 */
export class DeleteSavedQuery implements Action {
  /**
   * @ignore
   */
  readonly type = SavedQueryActionTypes.DeleteSavedQuery;

  /**
   * Contains id of saved query to be removed
   * @param payload {Object}
   */
  constructor(public payload: { id: string }) {
  }
}


/**
 * @ignore
 */
export type SavedQueryActions =
  AddSavedQuery
  | AddSavedQueries
  | DeleteSavedQuery;
